import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiEnvelope, ApiPublicUser, AuthResultDto } from '../models/auth-api.model';

export interface RedeemPromotionCodeResult {
  activated: boolean;
  alreadyActive: boolean;
  promotionCode: {
    id: string;
    code: string;
    maxUses: number;
    usedCount: number;
  };
  redemption: {
    id: string;
    createdAt: string;
    promotionCodeId: string;
    userId: string;
  };
  auth?: AuthResultDto;
  /** Convenience: user from auth payload when present. */
  user?: ApiPublicUser;
}

/** Student/teacher promotion-code redeem against `api/v1/identity/promotion-codes`. */
@Injectable({ providedIn: 'root' })
export class PromotionCodeApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/identity/promotion-codes`;

  /** Authenticated redeem for the current session user. */
  redeemForMe(code: string): Observable<RedeemPromotionCodeResult> {
    return this.http
      .post<ApiEnvelope<RedeemPromotionCodeResult>>(`${this.base}/redeem/me`, { code })
      .pipe(map((r) => r.data));
  }

  /** Public redeem with credentials (activates + returns auth tokens). */
  redeemWithCredentials(
    code: string,
    email: string,
    password: string,
  ): Observable<RedeemPromotionCodeResult> {
    return this.http
      .post<ApiEnvelope<RedeemPromotionCodeResult>>(`${this.base}/redeem`, {
        code,
        email,
        password,
      })
      .pipe(map((r) => r.data));
  }
}
